import { createSelector } from 'reselect';

import { getDataState, getUIState } from 'modules/dealerConfiguration/sales/selectors';

export const getDefaultClippingMedia = createSelector(getDataState, data => data.defaultClippingMedias);

export const isLoadingDefaultClippingMedia = createSelector(getUIState, ui => ui.clipping.isFetching);
